import { useTranslation } from "react-i18next";
import { ScrollTop } from 'primereact/scrolltop';
import { Button } from 'primereact/button';
import {useRef, useState } from "react";
import {useReactToPrint} from "react-to-print"
import React from "react";
import { Toolbar } from "primereact/toolbar";
import postConsultaWebService from '../../service/postConsultaWeb/postConsultaWebService';
import { FilterWeb } from "../../interface/FilterWeb";
import { useGlobalState } from "../../components/globalState/GlobalStateProvider";
import { Card } from "primereact/card";
import infoPositiva from "../../assets/infopositiva_login.png"
import quodImg from "../../assets/quod.png"
import { Message } from "primereact/message";
import RespostaInsumoPage from "./resposta/RespostaInsumo";


export default function ConsultaPage({
  resposta,
  onClose,
  original
}: {
  resposta: any
  onClose: () => void,
  original: boolean
}) {
  const { t } = useTranslation();
  const print = useRef(null);
  const [consultouProtesto, setConsultouProtesto] = useState<boolean>(false);
  const [consultouPendencia, setConsultouPendencia] = useState<boolean>(false);
  const {state} = useGlobalState();
  const handlePrint = useReactToPrint({
    content : () => print.current,
   
  })
   const handleConsulta = (opcao:string)  =>  {
    const filterWeb : FilterWeb = {
      documento: resposta.informativo.documento.replaceAll('.','').replaceAll('-', '').replaceAll('/', '') + '',
      consultas: [opcao],
      valor: undefined,
      arrojado: undefined,
      usual: undefined,
      conservador: undefined,
      indicadores: []

    }
    postConsultaWebService(filterWeb)
    .then((data:any) => {
      window.scrollTo(0, 0);
      data.dadosConsulta = resposta.dadosConsulta
      data.dadosConsultaPJ = resposta.dadosConsultaPJ
      localStorage.setItem('resposta', JSON.stringify(data));
      window.open('./consultar','_blank')
    })
  }
  const startContent = (
    <React.Fragment>
        <Button label="Imprimir" icon="pi pi-print" style={{backgroundColor:'#183462'}} onClick={() => {handlePrint()}}/>
        { original && state.user.funcoes.includes('PROTESTO_INFO') && (<Button disabled={consultouProtesto} label="Protesto Nacional - CENPROT" icon="pi pi-search-plus" style={{backgroundColor:'#183462', marginLeft: '2.5rem'}} onClick={() => {setConsultouProtesto(true); handleConsulta('PROTESTO_INFO')}}/>)} 
        { original && !state.user.funcoes.includes('PROTESTO_INFO') && state.user.funcoes.includes('PROTESTO_TOOLSDATA') && (<Button disabled={consultouProtesto} label="Protesto Nacional - CENPROT" icon="pi pi-search-plus" style={{backgroundColor:'#183462', marginLeft: '2.5rem'}} onClick={() => {setConsultouProtesto(true); handleConsulta('PROTESTO_TOOLSDATA')}}/>)} 
        { original && state.user.funcoes.includes('PENDENCIA_TOOLSDATA') && (<Button disabled={consultouPendencia} label="Restrições do Mercado" icon="pi pi-search-plus" style={{backgroundColor:'#183462', marginLeft: '2.5rem'}} onClick={() => {setConsultouPendencia(true); handleConsulta('PENDENCIA_TOOLSDATA')}}/>)}  
    </React.Fragment>
);

const endContent = (
  <React.Fragment>
      <Button icon="pi pi-times" onClick={onClose} rounded outlined severity="danger" aria-label="Cancel" />  
  </React.Fragment>
);

const razaoSocialOuNome = '';
const rodapeMensagem = `ATENÇÃO: As informações deste relatório são confidenciais e deverão ser utilizadas exclusivamente para orientação das transações comerciais, responsabilizando-se civil e criminalmente por danos causados a terceiros, quando da utilização em desacordo com a legislação em vigor.`;

return (<>
  <Toolbar start={startContent} end={endContent}/>
  <br></br>
  <br></br>
    <div ref={print} className="flex flex-column align-items-center" >
    <style type="text/css" media="print">{"\
  @page {\ size: portrait; font-size: 6pt; .label-dados {font-size: 6pt;}; margin: 1.5rem 1.5rem 1.5rem 1.5rem !important;\ }\
"}</style>
      <br></br>
      <Card>
        <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <img src={infoPositiva} style={{width:'300px'}}></img>
          </div>
          <div style={{textAlign:'center'}} className="col p-fluid flex flex-wrap">
            
          </div>
          <div style={{textAlign:'center'}} className="col p-fluid flex flex-wrap">
            {original && (<img src={quodImg} style={{width:'250px'}}></img>)}
          </div>
        </div>
      </Card>
      <br></br>
      <br></br>
      <RespostaInsumoPage resposta={resposta}></RespostaInsumoPage>
      <ScrollTop style={{marginBottom:'5rem'}} className="border-round bg-primary" icon="pi pi-arrow-up text-base" />
      <br></br>
      <Card>
        <Message className="messageResposta" style={{fontSize:'10'}} severity="warn" text={rodapeMensagem} />
      </Card>
    </div>
    <br></br>
    <br></br>
    <Toolbar start={startContent} end={endContent}/>
    <br></br>
    <br></br>
    <br></br>
    <br></br>
  </>)
}
